import m from "../../geodata/es2015/capeVerdeLow";
window.am4geodata_capeVerdeLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/capeVerdeLow.js
// module id = null
// module chunks = 